import React, { useEffect, useState } from "react";
import { Field, Formik, Form } from "formik";
// import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Box, Typography, makeStyles } from "@material-ui/core";
import InputUpload from "components/Input/InputUpload";
import AppColor from "utilities/AppColor";
import { useDispatch, useSelector } from "react-redux";
import { updateAgreementStaff } from "store/slices/company";
import { updateAgreementParticipant } from "store/slices/company";
import { updateAgreementStaffTax } from "store/slices/company";
import AppDialog from "components/Dialog/AppDialog";
import ComponentLoading from "components/Common/ComponentLoading";
import { getCompanyConfig } from "store/slices/company";

const styles = makeStyles(() => ({
    title: {
        display: 'flex',
        margin: '2rem 0 1rem 0'
    },
    control: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },
    textDownload: {
        cursor: 'pointer',
        '& span': {
        color: AppColor.blue,
        textDecoration: 'underline',
        marginRight: '0.5rem'
        }

    },
    link: {
        color: '#0056b3',
        textDecoration: 'underline',
        cursor: 'pointer',
        wordBreak: 'break-word'
    }
}));

const initValue = {
    workerDownloadAgreementFile: null,
    clientDownloadAgreementFile: null,
    workerDownloadAgreementTaxFile: null
};

const UploadAgreementFileTable = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const classes = styles();
    const companyConfig = useSelector(getCompanyConfig) || {};
    const [loading, setLoading] = useState(false);
    const [initForm, setInitForm] = useState({ ...initValue });
    const hostname = window.location.hostname;

    const handleUpdateAgreementStaff = async (file) => {
        if (file && file.name) {
            setLoading(true);
            await dispatch(updateAgreementStaff({ file, domain: hostname }));
            setLoading(false); 
        }
       
    };
    const handleUpdateAgreementParticipant = async (file) => {
        if (file && file.name) {
            setLoading(true);
            await dispatch(updateAgreementParticipant({ file, domain: hostname }));
            setLoading(false);
        }
    };
    const handleUpdateAgreementStaffTax = async (file) => {
        if (file && file.name) {
            setLoading(true);
            await dispatch(updateAgreementStaffTax({ file, domain: hostname }));
            setLoading(false);
        }
    };

    useEffect(() => {
        if (companyConfig) {
            setInitForm({
                clientDownloadAgreementFile: companyConfig.clientDownloadAgreementFile,
                workerDownloadAgreementFile: companyConfig.workerDownloadAgreementFile,
                workerDownloadAgreementTaxFile: companyConfig.workerDownloadAgreementTaxFile
            });
        }
    }, [companyConfig]);

  return (
    <Formik
        enableReinitialize={true}
        initialValues={{ ...initForm }}
    >
        {() => {
            return (
                <Form className={`${classes.container}`}>
                    <Box className={classes.title}>
                        <Typography variant="h5">
                            {t("label.participant")}
                        </Typography>
                    </Box>
                    <Box>
                        <Box display="flex" alignItems="center">
                            <span>{t('label.clientDownloadAgreementFile')}</span>
                        </Box>
                        <Field
                            component={InputUpload}
                            name="clientDownloadAgreementFile"
                            accept="application/pdf"
                            onUploadFile={handleUpdateAgreementParticipant}
                            resetInputAfterChangeFile={true}
                            showIconUpload={true}
                            showIconDownload={initForm.clientDownloadAgreementFile}
                            renderIconDownload={() => (
                            <a
                                style={{ marginLeft: '1rem' }}
                                href={companyConfig.clientDownloadAgreementFileAws3Link}
                                download={initForm.clientDownloadAgreementFile}
                            >
                                <Box className={classes.textDownload}>
                                <i className="fas fa-download"></i>
                                </Box>
                            </a>
                            )}
                        />
                    </Box>
                    <Box className={classes.title}>
                        <Typography variant="h5">
                            {t("label.worker")}
                        </Typography>
                    </Box>
                    <Box>
                        <Box display="flex" alignItems="center">
                            <span>{t('label.workerDownloadAgreementFile')}</span>
                        </Box>
                        <Field
                            component={InputUpload}
                            name="workerDownloadAgreementFile"
                            accept="application/pdf"
                            onUploadFile={handleUpdateAgreementStaff}
                            resetInputAfterChangeFile={true}
                            showIconUpload={true}
                            showIconDownload={initForm.workerDownloadAgreementFile}
                            renderIconDownload={() => (
                            <a
                                style={{ marginLeft: '1rem' }}
                                href={companyConfig.workerDownloadAgreementFileAws3Link}
                                download={initForm.workerDownloadAgreementFile}
                            >
                                <Box className={classes.textDownload}>
                                <i className="fas fa-download"></i>
                                </Box>
                            </a>
                            )}
                        />
                    </Box>
                    <Box>
                        <Box display="flex" alignItems="center">
                            <span>{t('label.fileAgreementForTax')}</span>
                        </Box>
                        <Field
                            component={InputUpload}
                            name="workerDownloadAgreementTaxFile"
                            accept="application/pdf"
                            onUploadFile={handleUpdateAgreementStaffTax}
                            resetInputAfterChangeFile={true}
                            showIconUpload={true}
                            showIconDownload={initForm.workerDownloadAgreementTaxFile}
                            renderIconDownload={() => (
                            <a
                                style={{ marginLeft: '1rem' }}
                                href={companyConfig.workerDownloadAgreementTaxFileAws3Link}
                                download={initForm.workerDownloadAgreementTaxFile}
                            >
                                <Box className={classes.textDownload}>
                                <i className="fas fa-download"></i>
                                </Box>
                            </a>
                            )}
                        />
                    </Box>
                    <AppDialog
                        open={loading}
                        onClose={() => setLoading(false)}
                        noTitle
                        noCloseButton
                        disableEscapeKeyDown
                    >
                        <Box my={3}>
                            <ComponentLoading />
                        </Box>
                    </AppDialog>
                </Form>
            );
        }}
    </Formik>
  );
};

UploadAgreementFileTable.propTypes = {
};

export default UploadAgreementFileTable;
